import { render, staticRenderFns } from "./reviews-list.vue?vue&type=template&id=6ff971c2&scoped=true&"
import script from "./reviews-list.vue?vue&type=script&lang=js&"
export * from "./reviews-list.vue?vue&type=script&lang=js&"
import style0 from "./reviews-list.vue?vue&type=style&index=0&id=6ff971c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff971c2",
  null
  
)

export default component.exports